export default {
  actions: {
    createPhoto({ dispatch, commit }, { organization, photoData }) {
      this.$authorize('edit', 'Organization')

      Vue.$http
        .post(`admin/organizations/${organization.id}/photos`, photoData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(
          () => dispatch('fetch', organization.id),
          () => commit('snackbar', { text: 'Photo could not be added', type: 'error' }, { root: true })
        )
    },

    editPhoto({ dispatch, commit }, { organization, photo }) {
      this.$authorize('edit', 'Organization')

      Vue.$http
        .patch(`admin/organizations/${organization.id}/photos/${photo.id}`, photo)
        .then(
          () => dispatch('fetch', organization.id),
          () => commit('snackbar', { text: 'Failed to save photo', type: 'error' }, { root: true })
        )
    },

    removePhoto({ dispatch, commit }, { organization, photo }) {
      this.$authorize('edit', 'Organization')

      Vue.$http
        .delete(`admin/organizations/${organization.id}/photos/${photo.id}`)
        .then(
          () => dispatch('fetch', organization.id),
          () => commit('snackbar', { text: 'Photo could not be removed', type: 'error' }, { root: true })
        )
    }
  }
}
